import React from 'react';
import { EditButton, Datagrid, TextField, DateField } from 'react-admin';
import TList from '../../components/wrapper/TList';

const BlackWhiteListList = props => (
	<TList exporter={false} {...props} sort={{ field: 'creationDateTime', order: 'DESC' }}>
		<Datagrid>
			<EditButton />
			<TextField source="id" sortable={false} />
			<DateField source="creationDateTime" showTime sortable={false} />
			<TextField source="blackWhiteListType" sortable={false} />
			<TextField source="name" sortable={false} />
		</Datagrid>
	</TList>
);

export default BlackWhiteListList;
